import React, { Component } from 'react';
import { connect } from 'react-redux';
import InfoMessage from './InfoMessage';
import { fetchVisibleBanners } from '../CroActions';

const severityToVariant = (severity) => {
    if (severity === 'WARNING') return 'warning';
    if (severity === 'CRITICAL') return 'error';
    return null;
};

const PATH_TO_ROLE = [
    [/^\/administrator/,        'ROLE_INTERNAL_OFFICIAL_ADMIN'],
    [/^\/spravce/,              'ROLE_INTERNAL_ADMIN'],
    [/^\/soudce/,               'ROLE_INTERNAL_JUDGE'],
    [/^\/podpurny-organ/,       'ROLE_OVM'],
    [/^\/opravneny-organ/,      'ROLE_LEGITIMATE'],
    [/^\/funkcionar/,           'ROLE_OFFICIAL'],
    [/^\/verejnost-prihlasen/,  'ROLE_PUBLIC'],
];

const getRoleForPath = (currentPath) => {
    if (!currentPath) return 'ROLE_ANONYMOUS';
    const match = PATH_TO_ROLE.find(([re]) => re.test(currentPath));
    return match ? match[1] : 'ROLE_ANONYMOUS';
};

class BannerList extends Component {
    state = { banners: [] };

    async componentWillMount() {
        await this.fetchBanners();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.currentPath !== this.props.currentPath) {
            await this.fetchBanners();
        }
    }

    fetchBanners = async () => {
        const role = getRoleForPath(this.props.currentPath);
        try {
            const banners = await fetchVisibleBanners(role)(this.props.dispatch);
            this.setState({ banners: banners || [] });
        } catch (e) {
            console.error('Failed to fetch banners', e);
        }
    };

    isMainPage = () => {
        const { currentPath, menuItems } = this.props;
        if (!currentPath || !Array.isArray(menuItems)) return false;
        if (currentPath === '/administrator/upozorneni') return false;
        if (currentPath === '/') return true;
        return menuItems.some((item) => item.path && item.path === currentPath);
    };

    render() {
        const { banners } = this.state;
        if (!banners.length) return null;
        if (!this.isMainPage()) return null;

        return (
            <div style={{ marginBottom: 20 }}>
                {banners.map((banner) => (
                    <InfoMessage key={banner.id} variant={severityToVariant(banner.severity)}>
                        {banner.text}
                    </InfoMessage>
                ))}
            </div>
        );
    }
}

export default connect()(BannerList);
